module.exports = __webpack_public_path__ + "static/media/nav-icon-course.f9e930fe.svg";